import {IconProps} from '../icon-props-interface';

const IconAlignRight = ({ color = 'var(--color-primary-2)' }: IconProps) => (
	<div className="icon-block">
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14 1.00195C14 1.55508 13.5531 2.00195 13 2.00195H6C5.44688 2.00195 5 1.55508 5 1.00195C5 0.448828 5.44688 0.00195312 6 0.00195312H13C13.5531 0.00195312 14 0.448828 14 1.00195ZM14 9.00195C14 9.55508 13.5531 10.002 13 10.002H6C5.44688 10.002 5 9.55508 5 9.00195C5 8.44883 5.44688 8.00195 6 8.00195H13C13.5531 8.00195 14 8.44883 14 9.00195ZM0 5.00195C0 4.44883 0.446875 4.00195 1 4.00195H13C13.5531 4.00195 14 4.44883 14 5.00195C14 5.55508 13.5531 6.00195 13 6.00195H1C0.446875 6.00195 0 5.55508 0 5.00195ZM14 13.002C14 13.5551 13.5531 14.002 13 14.002H1C0.446875 14.002 0 13.5551 0 13.002C0 12.4488 0.446875 12.002 1 12.002H13C13.5531 12.002 14 12.4488 14 13.002Z"
				fill={color}
			/>
		</svg>
	</div>
);

export default IconAlignRight;
